import { LocalImage, RecordWithImageFields } from './types';

/** Checks if the given record has an image set */
export const hasImage = (item: RecordWithImageFields): boolean =>
  !!(item.image || item.profilePicture || item.imageUrl || item.imageUpload);

/** Extracts image related fields from a record */
export const getImageFieldsFromRecord = <T extends RecordWithImageFields>(
  record: T
): RecordWithImageFields => ({
  image: record.image,
  imageCache: record.imageCache,
  s3ImageUrl: record.s3ImageUrl,
  imageUrl: record.imageUrl,
  imageUpload: record.imageUpload,
  profilePicture: record.profilePicture,
});

export const getEmptyImageFields = (): RecordWithImageFields => ({
  image: undefined,
  imageCache: undefined,
  s3ImageUrl: undefined,
  imageUrl: undefined,
  imageUpload: undefined,
});

export const setImageUpload = (
  imageUpload: LocalImage
): RecordWithImageFields => ({
  ...getEmptyImageFields(),
  imageUpload,
});

export const setImageUrl = (imageUrl: string): RecordWithImageFields => ({
  ...getEmptyImageFields(),
  imageUrl,
});

export const setImageFieldsFromInput = <T extends RecordWithImageFields>(
  item: T,
  {
    url,
    imageUpload,
  }: {
    url?: string;
    imageUpload?: LocalImage;
  }
): T => {
  if (url) {
    return {
      ...item,
      ...setImageUrl(url),
    };
  } else if (imageUpload) {
    return {
      ...item,
      ...setImageUpload(imageUpload),
    };
  }

  return item;
};

export const clearImageFields = <T extends RecordWithImageFields>(
  record: T
): T => ({
  ...record,
  s3ImageUrl: undefined,
  imageUpload: undefined,
  imageUrl: undefined,
  image: undefined,
});
